/* global $ */

export class DropdownControl {
	constructor(el) {
		// click dropdowns to toggle them open/closed
		$(el)
			.find('.button')
			.on('click', (e) => {
				e.preventDefault()

				// close all other dropdowns
				this.closeAllExcept($(el))

				// open this dropdown
				$(el).toggleClass('open')
			})

		// esc button
		$(window).on('keyup', (e) => {
			if (e.keyCode === 27) {
				this.closeAllExcept()
			}
		})

		// click anywhere to close
		$(window).on('click', (e) => {
			if ($(e.target).closest('.dropdown').length === 0) {
				this.closeAllExcept()
			}
		})
	}

	closeAllExcept($except) {
		$('.dropdown').not($except).removeClass('open')
	}
}
